import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import store from "./redux/store";
import Router from "./router";
import AuthLayer from "./router/authLayer";
import ThemeLayer from "./router/themeLayer";
import GALayer from "./router/gaLayer.js";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
const Component = () => {
    return (
        <Provider store={store}>
            <GALayer />
            <ThemeLayer>
                <AuthLayer><Router /></AuthLayer>
            </ThemeLayer>
        </Provider>
    );
};
root.render(<Component />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
